import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import { DateDropDownPickerWrapper, SelectWrapper } from './DatePickerMDY.style';

class DatePickerMDY extends React.PureComponent {
    static propTypes = {
        selected: PropTypes.string,
        disabled: PropTypes.boolean,
        dateFormat: PropTypes.string,


        onChange: PropTypes.func,
        onFocus: PropTypes.func,
        onBlur: PropTypes.func,
    };

    constructor(props, context){
        super(props, context);

        let selectedDate = props.selected && moment(props.selected.split('-'), props.dateFormat);

        this.state = {
            data: {
                months: Array.apply(0, Array(12)).map((_, i) => moment().month(i).format('MMM')),
                days: Array.from({length: 31}, (v, k) => k + 1),
                years: Array.from({length: 100}, (v, k) => parseInt(moment().subtract(18, 'years').get('year')) - k)
            },
            hasValidDate: props.selected && selectedDate._isValid || false,
            selectedDate: props.selected && selectedDate || null,
            selected: {
                months: selectedDate && selectedDate.month(selectedDate.month()).format("MMM") || null,
                days: selectedDate && selectedDate.date() || null,
                years: selectedDate && selectedDate.year() || null,
            }
        }
    }

    generateDate() {
        const {onChange } = this.props;
        let {years, months, days} = this.state.selected;
        let selectedDate = moment([days, months, years].join('-'), "D-MMM-YYYY");

        onChange(selectedDate);
        this.setFocus('onFocus');
        this.setFocus('onBlur')

        this.setState({
            ...this.state,
            hasValidDate: selectedDate._isValid,
            selectedDate: selectedDate._isValid ? selectedDate : null
        })
    }

    _onChange(e){
        e.persist();
        this.setState( (prevState, props) => ({
            ...prevState,
            selected: {
                ...prevState.selected,
                [e.target.name] : prevState.data[e.target.name][e.target.value]
            }
        }), () => {
            let {selected, data} = this.state;
            let selectedAll = Object.keys(selected).filter(key => selected[key] !== null).length === Object.keys(data).length;

            if (selectedAll) {
                this.generateDate()
            }
        });
    }

    setFocus(action) {
        const {onBlur, onFocus} = this.props;

        if (action === 'onBlur' && onBlur) {
            onBlur()
        } else if (action === 'onFocus' && onFocus) {
            onFocus()
        }
    }

    render() {
        const {data, selected, hasValidDate, selectedDate} = this.state;
        let selectedAll = Object.keys(selected).filter(key => selected[key] !== null).length === Object.keys(data).length;
        let selectedDateArr = [];

        if(selectedAll && hasValidDate){
            selectedDateArr = selectedDate.format("D-MMM-YYYY").split('-')
        }

        return (
            <DateDropDownPickerWrapper>
                { Object.keys(data).map((key, id) => (
                    <SelectWrapper key={key + id}>
                        <select disabled={this.props.disabled} name={key}
                                onChange={this._onChange.bind(this)}
                                onBlur={this.setFocus.bind(this, 'onBlur')}
                                onFocus={this.setFocus.bind(this, 'onFocus')}
                                value={selected[key] != null && data[key].includes(selected[key]) ? data[key].indexOf(selected[key]) : ''}>
                            <option value='' disabled>
                                {key.charAt(0).toUpperCase() + key.slice(1).slice(0, -1)}
                            </option>
                            { data[key].map((innerKey, idx) => (
                                <option key={idx + id}
                                        value={idx}>
                                    {innerKey}
                                </option>
                            ))}
                        </select>
                    </SelectWrapper>
                )) }
            </DateDropDownPickerWrapper>
        );
    }
}

export default DatePickerMDY;
